import React, {useEffect, useMemo} from 'react';
import {useHistory, useRouteMatch} from 'react-router-dom';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';

import {useQuery} from '../../helpers/common';
import ClientsSearchResults from './ClientsSearchResults/ClientsSearchResults';
import DealSearchResults from './DealSearchResults/DealSearchResults';

import './search-results.scss';
import '../../assets/styles/components/_tables.scss';
import {useSelector} from "react-redux";
import Loader from "../Users/Loader/Loader";


const SearchResults = ({setTitlePage}) => {
  const query = useQuery();
  const history = useHistory();
  const match = useRouteMatch();
  const searchTab = match.params.searchTab;
  const {accessFeatures, isLoadingConfiguration} = useSelector(({user}) => user);

  const path = match.url.replace(searchTab, '');
  const queryTerm = useMemo(() => query.get('term'), [query])

  const handleClick = (e) => {
    if (window.getSelection().toString()) {
      e.stopPropagation()
    }
  }

  useEffect(() => {
    accessFeatures['title.header_section'] &&
    setTitlePage(queryTerm ? `Результат поиска по запросу '${queryTerm}'` : 'Результаты поиска')

  }, [isLoadingConfiguration, queryTerm]);

  return (
    <main className="app-content">
      {isLoadingConfiguration ?
        (<div className="content-inner">
            <Loader pageRange={1}/>
          </div>) :
        <>
          {
            !accessFeatures['title.header_section'] &&
            <div className="content-header">
              <h1>{queryTerm ? `Результат поиска по запросу '${queryTerm}'` : 'Результаты поиска'}</h1>
            </div>

          }
          <div className="content-inner">
            <div className="content-inner-data">
              <Tabs
                selectedIndex={searchTab === 'clients' ? 0 : 1}
                className={'wrapper'}
                onSelect={(index) => {
                  history.push(path + (index === 0 ? 'clients' : 'deals'));
                }}>
                <TabList className="content-tabs offset-center">
                  <Tab className="content-tabtrigger button-white" selectedClassName="active"  onClick={handleClick}>
                    Клиенты
                  </Tab>
                  <Tab className="content-tabtrigger button-white" selectedClassName="active"  onClick={handleClick}>
                    Договоры
                  </Tab>
                </TabList>
                <TabPanel>
                  <ClientsSearchResults/>
                </TabPanel>
                <TabPanel>
                  <DealSearchResults/>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </>
      }

    </main>
  );
};

export default SearchResults;
